import { p as prisma } from "../../../../chunks/prisma.js";
const load = (async ({ depends }) => {
  depends("update:order");
  try {
    const orders = await prisma.order.findMany({
      include: {
        ProductOnOrder: {
          include: { product: true }
        },
        user: true
      },
      orderBy: { createdAt: "desc" }
    });
    return { orders };
  } catch (e) {
    console.log("Error loading orders", e);
    return { orders: [] };
  }
});
export {
  load
};
